import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import "./App.css";

import { BrowserRouter } from "react-router-dom";

import { Toaster } from "react-hot-toast";

import Routers from "./router";
import { MetrusProvider } from "shared/providers";
declare module "@mui/material/styles" {
  interface Theme {
    status: {
      danger: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}

const theme = createTheme({
  typography: {
    fontFamily: ["Open Sans"].join(","),
  },
  palette: {
    primary: {
      main: "#448d5f",
      contrastText: "#000",
    },
    secondary: {
      light: "#000",
      main: "#000",
      contrastText: "#448d5f",
    },
  },
  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: "h4" },
          style: {
            fontSize: "16px",
            fontWeight: "bold",
            color: "#448d5f",
          },
        },
        {
          props: { variant: "h5" } /* component props */,
          style: {
            fontSize: "18px",
            fontWeight: "bold",
            color: "#448d5f",
          },
        },
        {
          props: { variant: "h6" } /* component props */,
          style: {
            fontSize: "14px",
            color: "000",
          },
        },
      ],
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: "transparent !important",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          color: "#000 !important",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "#000 !important",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#448d5f",
          color: "#FFF",
          border: "1px solid transparent",
          padding: "8px 12px",
          "&:hover": {
            color: "#448d5f",
            backgroundColor: "#FFF",
            border: "1px solid #448d5f",
          },
          "&.Mui-disabled": {
            backgroundColor: "#E0E0E0",
            color: "#9E9E9E",
            border: "1px solid #BDBDBD",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          marginTop: "20px",
          padding: "10px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          margin: "15px 0",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: "15px 0",
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          marginTop: "20px",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        maxWidthXl: {
          maxWidth: "1048px !important",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "Open Sans, sans-serif",
          backgroundColor: "white",
          paddingRight: "5px",
        },
      },
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: "Open Sans, sans-serif",
        },
      },
    },
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <MetrusProvider>
          <Routers />
          <Toaster />
        </MetrusProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
